import React, { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import Index from "../pages/Index";
import Login from "../pages/Login";

import Page404 from "../pages/Page404";
import Register from "../pages/Register";
import Perfil from "../pages/Perfil";
import Admin from "../pages/Admin";
import api from "../api/axios";
import PasswordForget from "../pages/PasswordForget";
import RegisterShort from "../pages/RegisterShort";
import Oportunidades from "../pages/Oportunidades";
import OportunidadeDetail from "../pages/OportunidadeDetail";
import Candidatar from "../pages/Candidatar";
import FullScreenLoader from "../components/FullScreenLoader";

export default function Routess() {
  function RequireAuth({ children }) {
    const [isValid, setIsValid] = useState(null);

    useEffect(() => {
      async function validate() {
        try {
          await api.get("/user/me");
          setIsValid(true);
        } catch (err) {
          setIsValid(false);
        }
      }
      validate();
    }, []);

    if (isValid === null) return <FullScreenLoader fadeOut={true} />;
    if (!isValid) return <Navigate to="/login" />;
    return children;
  }

  function AlreadyLogged({ children }) {
    const [isLoggedIn, setIsLoggedIn] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const { paramId } = useParams();

    useEffect(() => {
      async function checkAuth() {
        try {
          await api.get("/user/me");
          setIsLoggedIn(true);
        } catch {
          setIsLoggedIn(false);
        }
      }

      checkAuth();
    }, []);

    useEffect(() => {
      if (
        isLoggedIn &&
        location.pathname.startsWith("/cadastro-oportunidade/")
      ) {
        navigate(
          `/candidatar/${location.pathname.split("/cadastro-oportunidade/")[1]}`
        );
      }
    }, [isLoggedIn, location.pathname, paramId, navigate]);

    if (isLoggedIn === null) return <FullScreenLoader fadeOut={true} />;

    if (
      isLoggedIn &&
      !location.pathname.startsWith("/cadastro-oportunidade/")
    ) {
      return <Navigate to="/perfil" />;
    }

    return children;
  }

  function RequireRole({ children, allowedRoles }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      async function validateRole() {
        try {
          const res = await api.get("/user/me");
          setUser(res.data);
        } catch (err) {
          setUser(null);
        } finally {
          setLoading(false);
        }
      }

      validateRole();
    }, []);

    if (loading) return <FullScreenLoader fadeOut={!loading} />;
    if (!user) return <Navigate to="/login" />;

    if (!allowedRoles.includes(user.role)) {
      if (user.role === "admin") return <Navigate to="/admin" />;

      return <Page404 />;
    }

    return children;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <AlreadyLogged>
            <Index />
          </AlreadyLogged>
        }
      />
      <Route
        path="/login"
        element={
          <AlreadyLogged>
            <Login />
          </AlreadyLogged>
        }
      />
      <Route
        path="/cadastro"
        element={
          <AlreadyLogged>
            <Register />
          </AlreadyLogged>
        }
      />
      <Route path="/oportunidades" element={<Oportunidades />} />
      <Route
        path="/oportunidade/:oportunidadeId"
        element={<OportunidadeDetail />}
      />
      <Route
        path="/candidatar/:paramId"
        element={
          <RequireAuth>
            <RequireRole allowedRoles={["user"]}>
              <Candidatar />
            </RequireRole>
          </RequireAuth>
        }
      />
      <Route
        path="/cadastro-oportunidade/:paramId"
        element={
          <AlreadyLogged>
            <RegisterShort />
          </AlreadyLogged>
        }
      />
      <Route
        path="/esqueci-senha"
        element={
          <AlreadyLogged>
            <PasswordForget />
          </AlreadyLogged>
        }
      />
      <Route
        path="/perfil"
        element={
          <RequireAuth>
            <RequireRole allowedRoles={["user"]}>
              <Perfil />
            </RequireRole>
          </RequireAuth>
        }
      />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <RequireRole allowedRoles={["admin"]}>
              <Admin />
            </RequireRole>
          </RequireAuth>
        }
      />
      <Route
        path="/editar-profissional/:paramId"
        element={
          <RequireAuth>
            <RequireRole allowedRoles={["admin"]}>
              <Perfil />
            </RequireRole>
          </RequireAuth>
        }
      />
      <Route
        path="*"
        element={
          <RequireAuth>
            <Page404 />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
